import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, Row, Col, Tag, Space } from 'antd';
import { PRESET_TAG_COLORS, IATA_STATUS_OPTIONS } from '../constants/tagConstants';

const UldTagForm = ({ 
    visible, 
    onCancel, 
    onSubmit, 
    editingTag = null, 
    loading = false 
}) => {
    const [form] = Form.useForm();

    // 当编辑标签或对话框显示状态变化时，重置表单
    useEffect(() => {
        if (visible) {
            if (editingTag) {
                // 编辑模式：填充现有数据
                form.setFieldsValue({
                    tag_name: editingTag.tag_name,
                    description: editingTag.description,
                    color_code: editingTag.color_code,
                    iata_equivalent_status: editingTag.iata_equivalent_status,
                });
            } else {
                // 新建模式：重置表单
                form.resetFields();
                form.setFieldsValue({
                    color_code: PRESET_TAG_COLORS[0], // 默认第一个颜色
                });
            }
        }
    }, [visible, editingTag, form]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            await onSubmit(values);
        } catch (error) {
            console.error('表单验证失败:', error);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    return (
        <Modal
            title={editingTag ? "编辑标签" : "创建标签"}
            open={visible}
            onOk={handleSubmit}
            onCancel={handleCancel}
            confirmLoading={loading}
            width={600}
            destroyOnHidden
        >
            <Form
                form={form}
                layout="vertical"
                name="tagForm"
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="tag_name"
                            label="标签名称"
                            rules={[
                                { required: true, message: '请输入标签名称' },
                                { max: 50, message: '标签名称最多50个字符' },
                            ]}
                        >
                            <Input 
                                placeholder="例如：维修中" 
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="iata_equivalent_status"
                            label="对应IATA状态码"
                        >
                            <Select 
                                placeholder="选择对应的IATA状态码（可选）"
                                allowClear
                                options={IATA_STATUS_OPTIONS}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item
                    name="description"
                    label="标签描述"
                    rules={[
                        { max: 500, message: '描述最多500个字符' },
                    ]}
                >
                    <Input.TextArea 
                        rows={3}
                        placeholder="描述该标签的用途和含义"
                    />
                </Form.Item>

                <Form.Item
                    name="color_code"
                    label="显示颜色"
                    rules={[
                        { required: true, message: '请选择标签颜色' },
                        { 
                            pattern: /^#[0-9A-Fa-f]{6}$/, 
                            message: '颜色格式不正确，应为#RRGGBB格式' 
                        },
                    ]}
                >
                    <Select placeholder="选择标签颜色">
                        {PRESET_TAG_COLORS.map(color => (
                            <Select.Option key={color} value={color}>
                                <Space>
                                    <Tag color={color} style={{ marginRight: 8 }}>
                                        示例
                                    </Tag>
                                    {color}
                                </Space>
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                {/* 预览区域 */}
                <Form.Item label="预览效果">
                    <Form.Item dependencies={['tag_name', 'color_code']} noStyle>
                        {({ getFieldValue }) => {
                            const tagName = getFieldValue('tag_name') || '标签名称';
                            const colorCode = getFieldValue('color_code') || PRESET_TAG_COLORS[0];
                            return (
                                <Tag color={colorCode} style={{ fontSize: '14px', padding: '4px 8px' }}>
                                    {tagName}
                                </Tag>
                            );
                        }}
                    </Form.Item>
                </Form.Item>

                {/* 移除系统标签特殊提示 */}
                {editingTag?.is_system_tag && (
                    <div style={{ 
                        padding: '8px 12px', 
                        backgroundColor: '#f0f2f5', 
                        border: '1px solid #d9d9d9',
                        borderRadius: '4px',
                        marginTop: '16px'
                    }}>
                        <span style={{ color: '#666' }}>
                            提示：这是一个系统标签，现在允许完全编辑。
                        </span>
                    </div>
                )}
            </Form>
        </Modal>
    );
};

export default UldTagForm; 